import 'whatwg-fetch';
import _ from 'lodash';
import settings from './settings';

function getLifeRayAuthToken() {
    if (window.Liferay) {
        return window.Liferay.authToken;
    }
    return settings.p_auth;
}

const getLifeRayLanguage = () => {
    if (window.Liferay) {
        return window.Liferay.ThemeDisplay.getLanguageId();
    }
    return "en_US";
}

function getQueryString(params) {
    const esc = encodeURIComponent;
    return _.keys(params)
        .map(k => `${esc(k)}=${esc(params[k])}`)
        .join('&');
}

const getUrl = (url, queryParams) => {
    if (_.keys(queryParams).length > 0) {
        url += `?${getQueryString(queryParams)}`;
    }
    return url;
};

export const getLifeRayUrl = () => {
    if (!window.Liferay) {
        return settings.lifeRayUrl;
    }
    return `${settings.lifeRayUrl}?p_auth=${getLifeRayAuthToken()}`;
};

const ApiUtils = {
    get(url, params = {}, options = {}) {
        options.method = 'get';
        if (!options.headers) 
            options.headers = {};
        if (!options.headers["Content-type"])
            options.headers["Content-type"]='application/json';
        if (!window.Liferay) {
            options.headers.Authorization = `Basic ${btoa(`${settings.liferay_username}:${settings.liferay_password}`)}`
        } else {
        	params.p_auth = getLifeRayAuthToken();
        }
        return this.fetch(url, params, options);
    },

    post(url, body, params = {}, options = {}) {
        options.method = 'post';
        options.body = body;
        return this.fetch(url, params, options);
    },
    /** POST Запрос формирует. по умолчанию  Content-type=application/json */
    postToLifeRay(body, options = {}) {
        options.method = 'post';
        if (!options.headers) 
            options.headers = {};
        if (!options.headers["Content-type"])
            options.headers["Content-type"]='application/json';
        if (!window.Liferay) {
            options.headers.Authorization =`Basic ${btoa(`${settings.liferay_username}:${settings.liferay_password}`)}`
        } else {
            options.credentials = 'same-origin';
        }
        options.body = JSON.stringify(body);
        return this.fetchFromLifeRay(options);
    },
    /** POST запрос для  721. Content-type=application/x-www-form-urlencoded; charset=UTF-8 
     * добавляется p_auth (при наличии). params - JSON объект с параметрами
    */
    postToLifeRay721(params, options = {}) {
        options.method = 'post';
        if (!options.headers) 
            options.headers = {};
        if (!options.headers["Content-type"])
            options.headers["Content-type"]='application/x-www-form-urlencoded; charset=UTF-8';
        if (!window.Liferay) {
            options.headers.Authorization =`Basic ${btoa(`${settings.liferay_username}:${settings.liferay_password}`)}`
        } else {
            params['p_auth', getLifeRayAuthToken()];
            options.credentials = 'same-origin';
        }
        options.body = getQueryString(params);
        return this.fetchFromLifeRay(options);
    },
    fetch(url, params = {}, options = {}) {
        const timeout = new Promise((resolve, reject) => {
            setTimeout(
                () =>
                    reject(
                        new Error({
                            message: "Connection to the Internet couldn't be established",
                        })
                    ),
                settings.loadTimeout
            );
        });

        let {baseUrl} = settings;
        if (options.baseUrl) {
            // eslint-disable-next-line prefer-destructuring
            baseUrl = options.baseUrl;
        }

        const getData = new Promise((resolve, reject) => {
            fetch(baseUrl + getUrl(url, params), options)
                .then(response => ApiUtils.checkStatus(response))
                .then(response => {
                    if (options.type === 'text') {
                        return response.text();
                    }
                    return response.json();
                })
                .then(json => {
                    resolve(json);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return Promise.race([timeout, getData]);
    },
    fetchFromLifeRay(options = {}) {
        const lifeRayTimeout = new Promise((resolve, reject) => {
            setTimeout(
                () =>
                    reject(
                        new Error({
                            message: "Connection to the Internet couldn't be established",
                        })
                    ),
                settings.loadTimeout
            );
        });

        const liferayGetData = new Promise((resolve, reject) => {
            //console.log("const liferayGetData = new Promise((resolve, reject) => {", options);
            fetch(getLifeRayUrl(), options)
                .then(response => ApiUtils.checkLiferayStatus(response))
                .then(response => {
                    //console.log("response !", response);
                    if (options.type === 'text') {
                        return response.text();
                    }
                    return response.json();
                })
                .then(json => {
                    if (json.error) {
                        throw json;
                    }
                    resolve(json);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return Promise.race([lifeRayTimeout, liferayGetData]);
    },
    checkStatus(response) {
        if (response.type === 'opaque') return response;
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        throw (response.error) ? response.error : `Ответ сервиса: ${response.statusText} (${response.status}).`;
    },
    checkLiferayStatus(response) {
        if (response.status >= 200 && response.status < 300) {
            return response;
        }
        if (response.status === 500) {
            return response;
        }
        throw response;
    },
    convertToSelectOptions(list) {
        return _.map(list, obj => ({value: obj.id, label: obj.name}));
    },
    convertToSelectOption(option) {
        if (option == null || !option.id) return '';
        return {value: option.id, label: option.name};
    },

    makeJSONWSurl(url, params = {}, options = {}){
        let {baseUrl} = settings;
        if (options.baseUrl) {
            // eslint-disable-next-line prefer-destructuring
            baseUrl = options.baseUrl;
        }
        if (window.Liferay) {
        	params.p_auth = getLifeRayAuthToken();
        }
        return baseUrl + getUrl(url, params)
    },

    /** Возвращает true, если есть объект Liferay */
    isLifeRayPresent(){
        return (window.Liferay)? true: false;
    },

    /** Возвращает двухбуквенный код языка */
    getLanguage(){
        //return "en";
        const lang = getLifeRayLanguage();
        if (lang){
            return lang.substring(0, 2);
        }else {
            return "en";
        }
    },

    /** Возвращает true, если есть пользователь залогонился */
    isSignedIn(){
        if (window.Liferay) return window.Liferay.ThemeDisplay.isSignedIn();
        //Если нужно тестить в режиме авторизации, то return true иначе return false
        return false;
    },
    
};

export default ApiUtils;
